'use strict';
/* eslint-disable */
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (dependencyName) {
  var benderStaticVersionString = hubspot.bender.depVersions[dependencyName];

  // Dependency version string will be "static" when running the project locally.
  if (!benderStaticVersionString || benderStaticVersionString === 'static') {
    return 1;
  }

  // Grab the version number from the formatted string.
  // EX: "static-3.4.5"
  return parseInt(benderStaticVersionString.substr(benderStaticVersionString.indexOf('-') + 1), 10);
};

module.exports = exports['default'];